import { apiFetch } from './api';

export interface WhatsAppStatus {
  isConnected: boolean;
  loggedIn: boolean;
  phoneNumber: string | null;
}

export async function getWhatsAppStatus(agentId: string): Promise<WhatsAppStatus> {
  const rs = await apiFetch<any>(`/whatsapp/status/${encodeURIComponent(agentId)}`, { auth: true });
  const data = rs?.data || rs;
  const jid: string | undefined = rs?.jid;
  const connectionType = rs?.connectionType;
  
  // Se o connectionType for 'zapi', não mostrar como conectado no WhatsApp nativo
  const isZApiConnection = connectionType === 'zapi';
  
  return {
    isConnected: isZApiConnection ? false : !!data?.connected,
    loggedIn: isZApiConnection ? false : !!data?.loggedIn,
    phoneNumber: jid ? jid.split(':')[0] : null,
  };
}

export async function startWhatsAppSession(agentId: string): Promise<string | null> {
  const rs = await apiFetch<any>(`/whatsapp/start/${encodeURIComponent(agentId)}`, { auth: true });
  const data = rs?.data || rs;
  // Check if the response contains a QR code (for cases where start returns QR directly)
  if (data?.QRCode) {
    return data.QRCode as string;
  }
  if (data?.qrCode) {
    return data.qrCode as string;
  }
  return null;
}

export async function getWhatsAppQRCode(agentId: string): Promise<string | null> {
  const rs = await apiFetch<any>(`/whatsapp/qr/${encodeURIComponent(agentId)}`, { auth: true });
  const data = rs?.data || rs;
  // Check for both possible property names: QRCode (uppercase) and qrCode (lowercase)
  if (data?.QRCode) {
    return data.QRCode as string;
  }
  if (data?.qrCode) {
    return data.qrCode as string;
  }
  return null;
}

export async function logoutWhatsApp(agentId: string): Promise<void> {
  await apiFetch<void>(`/whatsapp/logout/${encodeURIComponent(agentId)}`, {
    method: 'POST',
    auth: true,
  });
}


